module.exports = __webpack_public_path__ + "img/waf-icon.81f882c.svg";